module.exports = "/static-assets/_next/static/images/suitcase-37f62caab2c9dbdd498c09d5a4a906e3.png";